import React from 'react';
import { Provider } from 'react-redux'
import configureStore from './configureStore.js'

const getStore = () => {
    const store = configureStore(true);
    return store;
}
let store = getStore();

const getStoreDecorator = (refreshStore) => {
  let myStore = store;
  if (refreshStore) {
    myStore = getStore();
  }

  return Story => {
    if (
      typeof Story === 'function' && 
      Story.prototype instanceof React.Component
    ) {
      return class extends React.Component {
        render() {
          return (
            <Provider store={myStore}>
              <Story
                {...this.props}
              />
            </Provider>
          )
        }
      }
    } else {
      return <Provider store={myStore}>
        { 
            typeof Story === 'function' ? Story() : Story
        }
      </Provider>;
    }
  }
}

export { store, getStore, getStoreDecorator } ;